import systemManage from './energy/systemManage'
import energyDisplay from './energy/energyDisplay'
import manageCenter from './energy/manageCenter'
import energyMonitor from './energy/energyMonitor'
import energyAnalyse from './energy/energyAnalyse'
import energyCount from './energy/energyCount'
import energyReport from './energy/energyReport'
import photovol from "./energy/photovol";
import customizeManage from "./energy/customizeManage";
import carbonManage from "./energy/carbonManage";
import extraDevice from "./energy/extraDevice";

export default {
  systemManage,
  energyDisplay,
  manageCenter,
  energyMonitor,
  energyAnalyse,
  energyCount,
  energyReport,
  photovol,
  customizeManage,
  carbonManage,
  extraDevice
}



// WEBPACK FOOTER //
// ./src/api/index.js